import BaseService from './base.service';

export default class OrderTrackingService extends BaseService {
  getOrderTracking(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/order-tracking${queryString}`);
  }

  putUserToCancelledStatus(userId) {
    return this.put(`/order-tracking/${userId}/cancelled`);
  }

  putUserToArchivedStatus(userId) {
    return this.put(`/order-tracking/${userId}/archived`);
  }

  putUserToRegisteredStatus(userId) {
    return this.put(`/order-tracking/${userId}/registered`);
  }

  putUserToPaidStatus(userId) {
    return this.put(`/order-tracking/${userId}/paid`);
  }

  putUserToCompleteStatus(userId) {
    return this.put(`/order-tracking/${userId}/complete`);
  }
}
